import Loader from '@/components/ui/loader'
// import { useAuth } from '@/context/AuthContext'
// import useAuthHook from '@/hooks/auth'
import { useToast } from '@/context/ToastContext'
import { useMobiApi } from '@/services/mobi-api'
import { GetLockedNumberRes, GetNumberListReq, NewNumber, lockedNumberList } from '@/services/mobi-api/number/types'
import useIntl from '@/utils/intl'
import classNames from 'classnames'
import React, { FunctionComponent, useEffect, useReducer } from 'react'
import DarkButton from '@/components/ui/Buttons/SecondaryButton'
import { Obj } from '..'
import { SaveNumberReqV2 } from '@/services/mobi-api/numberv2/types'
import { isNil } from '@/utils/validations'
import { useLanguage } from '@/context/LanguageContext'
const digits: Record<number, string[]> = {
  0: ['*', '8', '9'],
  1: ['*', '4', '5', '9'],
  2: ['*', '1', '2', '3', '4', '5', '6', '7', '8', '9', '0'],
  3: ['*', '1', '2', '3', '4', '5', '6', '7', '8', '9', '0'],
  4: ['*', '1', '2', '3', '4', '5', '6', '7', '8', '9', '0'],
  5: ['*', '1', '2', '3', '4', '5', '6', '7', '8', '9', '0'],
  6: ['*', '1', '2', '3', '4', '5', '6', '7', '8', '9', '0'],
  7: ['*', '1', '2', '3', '4', '5', '6', '7', '8', '9', '0']
}
const prefixes = [
  '85', '94', '95', '99'
]
interface State {
  isdn?: string
  clickedPrefix?: string
  currentPage?: number
  numberList?: NewNumber[]
  loading?: boolean
  lockedNumbers?: GetLockedNumberRes
  lockedNumberDialog?: boolean
  chosenLockedNumber?: lockedNumberList
  invalidNumber?: boolean
}

interface Props {
  next: (obj: Obj) => void
  instanceId: string
  rateplan: string
}

const ChooseNumber: FunctionComponent<Props> = ({ next, instanceId, rateplan }) => {
  const { translate } = useIntl()
  const { showError } = useToast()
  const { numberv2 } = useMobiApi()
  const { locale } = useLanguage()
  // const { isdn } = useAuthHook()
  const [state, setState] = useReducer(
    (state: State, newState: State) => ({ ...state, ...newState }),
    {
      loading: true,
      isdn: '********',
      currentPage: 1,
      lockedNumberDialog: false,
      invalidNumber: true
    }
  )

  // useEffect(() => {
  //   void getLockedNumber()
  // }, [])

  useEffect(() => {
    if (rateplan !== undefined && rateplan !== null && rateplan !== '') {
      void getNumberList()
    }
  }, [rateplan])

  useEffect(() => {
    void getNumberListChangePattern()
  }, [state.isdn])

  useEffect(() => {
    validateChosenNumber(state.isdn)
  }, [state.numberList])

  useEffect(() => {
    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [state.currentPage])

  const validateChosenNumber = (isdn?: string): void => {
    if (!(isdn ?? '********').includes('*')) {
      const { numberList = [] } = state ?? {}
      const [filter] = numberList.filter((n) => n.number === isdn)
      if (!isNil(filter)) {
        setState({ invalidNumber: false })
      }
    }
  }

  const replaceCharAtIndex = (inputString: string, index: number, newChar: string): string => {
    if (index < 0 || index >= inputString.length) {
      return inputString
    }
    const stringArray = inputString.split('')
    stringArray[index] = newChar
    const resultString = stringArray.join('')
    return resultString
  }

  const getNumberList = async (): Promise<void> => {
    const Req: GetNumberListReq = {
      pattern: (state.isdn)?.replaceAll('*', '_'),
      page: state.currentPage,
      rateplan
    }
    try {
      setState({ loading: true })
      setState({ invalidNumber: true })
      const res = await numberv2.getNumberListV2(Req)
      if (res !== undefined && res.data.length > 0) {
        const init = [...state.numberList ?? [], ...res.data]
        setState({ numberList: init })
      }
    } catch (e) {
      showError(translate('error'))
    } finally {
      setState({ loading: false })
    }
  }

  // const getLockedNumber = async (): Promise<void> => {
  //   try {
  //     setState({ loading: true })
  //     const res = await number.getLockedNumbers(isdn ?? '')
  //     if (res !== undefined && res?.list.length > 0) {
  //       setState({ lockedNumberDialog: true, lockedNumbers: res })
  //     }
  //   } catch (e) {
  //     console.error('get locked numbers failed: ', e)
  //   } finally {
  //     setState({ loading: false })
  //   }
  // }

  const getNumberListChangePattern = async (): Promise<void> => {
    if (prefixes.includes(state.isdn?.slice(0, 2) ?? '')) {
      setState({ clickedPrefix: state.isdn?.slice(0, 2) ?? '' })
    }
    const Req: GetNumberListReq = {
      pattern: (state.isdn)?.replaceAll('*', '_'),
      page: 1,
      rateplan
    }
    try {
      setState({ loading: true })
      setState({ invalidNumber: true })
      const res = await numberv2.getNumberListV2(Req)
      if (res !== undefined) {
        setState({ numberList: res.data })
      }
    } catch (e) {
      showError(translate('error'))
    } finally {
      setState({ loading: false })
    }
  }

  const handleSetPrefixes = (id: number, num: string): void => {
    const tempIsdn = replaceCharAtIndex(state.isdn ?? '', 0, num.split('')[0])
    const tempIsdn2 = replaceCharAtIndex(tempIsdn ?? '', 1, num.split('')[1])
    const changedISDN = tempIsdn2.substring(0, 2) + tempIsdn2.substring(2).replace(/./g, '*')
    setState({ clickedPrefix: prefixes[id], isdn: changedISDN })
  }

  const handleChangeIsdn = (event: any, i: number): void => {
    const tempIsdn = replaceCharAtIndex(state.isdn ?? '', i, event.target.value)
    setState({ isdn: tempIsdn })

    const first = prefixes.map(prefix => parseInt(prefix[0]))
    const secondDigits = prefixes.map(prefix => parseInt(prefix[1]))

    first.forEach((digit, index) => {
      if (i === 0 && digit !== event.target.value) {
        setState({ clickedPrefix: undefined })
      }
    })
    secondDigits.forEach((digit, index) => {
      if (i === 1 && digit !== event.target.value) {
        setState({ clickedPrefix: undefined })
      }
    })
  }

  const handleScroll = (): void => {
    const scrollY = window.scrollY
    const windowHeight = window.innerHeight
    const documentHeight = document.documentElement.scrollHeight
    if (scrollY + windowHeight >= documentHeight) {
      setState({ currentPage: (state.currentPage ?? 0) + 1 })
    }
  }

  const handleSaveNumber = async (): Promise<void> => {
    try {
      const req: SaveNumberReqV2 = {
        instanceId,
        number: state.isdn ?? ''
      }
      const res = await numberv2.saveNumberV2(req)
      if (res !== undefined && res.error === undefined) {
        next({ choosenNumber: state.isdn ?? '' })
      } else {
        showError(locale === 'en' ? (res?.cause?.messageEn ?? (res?.error ?? translate('request.failed'))) : res?.cause?.messageMn ?? (res?.error ?? translate('request.failed')))
      }
    } catch (e) {
      showError(translate('request.failed'))
    } finally {
      setState({ loading: false })
    }
  }

  return (
    <div className='rounded-xl bg-surfaceMid w-full justify-start overflow-auto relative flex flex-col md:p-8 p-4'>
      <div className='flex-1 rounded-2xl bg-surfaceInverse'>
        <div className='border rounded-2xl border-secondaryHighStroke bg-surfaceLow p-3 flex flex-col gap-3'>
          <span className='text-textMid text-sm font-bold'>{translate('number.search')}</span>
          <div className='flex w-full'>
            {(state.isdn ?? '').split('').map((num, i) => (
              <div key={i} className='flex justify-center items-center border rounded-xl aspect-square w-full text-textHigh bg-surfaceInverse'>
                <select name='' value={state.isdn !== undefined ? state.isdn[i] : ''} className='w-auto appearance-none bg-surfaceInverse' onChange={(e) => handleChangeIsdn(e, i)}>
                  {digits[i].map((item, id) => (
                    <option value={item} key={id}>{item}</option>
                  ))}
                </select>
              </div>
            )
            )}
          </div>
          <DarkButton disabled={state.invalidNumber} fullwidth onClick={() => { void handleSaveNumber() }}>{translate('choose')}</DarkButton>
          <span className='text-textMid text-sm font-bold'>{translate('number.available')}</span>
          <div className='flex gap-2 w-full justify-center'>
            {prefixes.map((item, id) => (
              <div key={id} className={classNames('w-1/5 border rounded-xl flex justify-center items-center aspect-[2/1] cursor-pointer bg-surfaceInverse', prefixes[id] === state.clickedPrefix ? 'border-primaryMainStroke' : 'border-secondaryMidStroke')} onClick={() => handleSetPrefixes(id, item)}>
                <span className='text-sm text-textHigh font-semibold'>{item}</span>
              </div>
            ))}
          </div>
        </div>
        <div className={classNames('grid grid-cols-2 gap-3 overflow-auto', state.numberList !== undefined && state.numberList?.length > 0 ? 'h-60 p-4' : '')}>
          {
            state.numberList?.map((item, id) => (
              <div key={id} className={classNames('border bg-surfaceInverse rounded-xl flex justify-center items-center aspect-[5/1] cursor-pointer p-1', item.number === state.isdn ? 'border-primaryMainStroke' : 'border-secondaryMidStroke')} onClick={() => { setState({ isdn: item.number }) }}>
                <span className='text-sm text-textHigh font-semibold'>{item.number}</span>
              </div>
            ))
          }
        </div>
        <div>
          {
            state.loading === true && (
              <div className='flex justify-center items-center'>
                <Loader />
              </div>
            )
          }
        </div>
      </div>
    </div>

  )
}
export default ChooseNumber
